<template>
  <v-main class="bg-primary">
    <div class="content-scroller">
      <slot />
    </div>
  </v-main>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ApplicationLayout',
})
</script>

<style scoped lang="scss"></style>
